import { IInventoryPage } from '../../inventory-page.interface';


export const USER_EMAIL_VERIFY_PAGE: IInventoryPage = {
	'route': '/user/email-verify',
	'title': 'Email Verification',
	'uiReference': [
		'Check your email',
		'Use the verification link in your inbox to activate your Flying account.',
		'This email address is invalid or no longer available for verification.',
		'We could not resend the verification email. Please try again.',
		'A new verification email was sent successfully.',
		'Resend verification email Try again in s',
		'Check your spam folder if the message does not arrive within a few minutes.',
		'Used the wrong email? Create your account again',
		'Flying account sign in',
		'Appearance',
		'One secure account for Flying Research and Flying Upload'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/email-verification/email-verification.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/email-verification/email-verification.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-shell/auth-shell.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/auth/auth-shell/auth-shell.component.html'
	]
};
